import { useSelectors } from '@exodus/headless-react';
import { useMemo } from 'react';
import { useSelector } from 'react-redux';
const useExchangeSpreadPercent = (params) => {
    const { fromAmount, toAmount, fromAsset, toAsset } = params;
    const selectors = useSelectors();
    const getFromUsdValue = useSelector(selectors.fiatBalances.createAssetConversionUsd(fromAsset.name));
    const getToUsdValue = useSelector(selectors.fiatBalances.createAssetConversionUsd(toAsset.name));
    return useMemo(() => {
        const fromUsdValue = getFromUsdValue(fromAmount);
        const toUsdValue = getToUsdValue(toAmount);
        if (fromUsdValue.isZero || toUsdValue.isZero)
            return null;
        const spread = fromUsdValue.sub(toUsdValue).div(fromUsdValue.toDefaultNumber()).mul(100);
        return spread.toDefaultNumber();
    }, [fromAmount, getFromUsdValue, getToUsdValue, toAmount]);
};
export default useExchangeSpreadPercent;
